function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-640 -200)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M18,0H47A18,18,0,0,1,65,18V47A18,18,0,0,1,47,65H18A18,18,0,0,1,0,47V18A18,18,0,0,1,18,0Z",
  transform: "translate(640 200)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(657 217)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M3,11.777A3.226,3.226,0,0,0,6.222,15h5.556A3.226,3.226,0,0,0,15,11.777V6.223A3.226,3.226,0,0,0,11.778,3H6.222A3.226,3.226,0,0,0,3,6.223ZM5,6.223A1.224,1.224,0,0,1,6.222,5h5.556A1.224,1.224,0,0,1,13,6.223v5.555A1.224,1.224,0,0,1,11.778,13H6.222A1.224,1.224,0,0,1,5,11.777Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M3,25.777A3.226,3.226,0,0,0,6.222,29h5.556A3.226,3.226,0,0,0,15,25.777V20.223A3.226,3.226,0,0,0,11.778,17H6.222A3.226,3.226,0,0,0,3,20.223Zm2-5.555A1.224,1.224,0,0,1,6.222,19h5.556A1.224,1.224,0,0,1,13,20.223v5.555A1.224,1.224,0,0,1,11.778,27H6.222A1.224,1.224,0,0,1,5,25.777Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M23,3a6,6,0,1,0,6,6,6,6,0,0,0-6-6Zm0,10a4,4,0,1,1,4-4,4,4,0,0,1-4,4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M20.222,17A3.226,3.226,0,0,0,17,20.223v5.555A3.226,3.226,0,0,0,20.222,29h5.556A3.226,3.226,0,0,0,29,25.777V20.223A3.226,3.226,0,0,0,25.778,17ZM27,20.223v5.555A1.224,1.224,0,0,1,25.778,27H20.222A1.224,1.224,0,0,1,19,25.777V20.223A1.224,1.224,0,0,1,20.222,19h5.556A1.224,1.224,0,0,1,27,20.223Z"
})));

function SvgTotalOrdersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalOrdersIcon);
export default __webpack_public_path__ + "static/media/total-orders-icon.d5e5c321.svg";
export { ForwardRef as ReactComponent };